import { render, staticRenderFns } from "./UploadStatutoryModal.vue?vue&type=template&id=56d6810c&"
import script from "./UploadStatutoryModal.vue?vue&type=script&lang=js&"
export * from "./UploadStatutoryModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadStatutoryModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports